import type { ActivityTarget, ActivityTargetKind } from '@coreltb/shared/validation';

interface DetailRoute {
  section: string;
  kind: ActivityTargetKind;
  /** Podstrony, które nie są identyfikatorem rekordu. */
  reserved: readonly string[];
}

const DETAIL_ROUTES: readonly DetailRoute[] = [
  { section: 'crm', kind: 'lead', reserved: ['nowy', 'koszyk'] },
  { section: 'oferty', kind: 'offer', reserved: ['nowa', 'prosby-o-usuniecie'] },
  { section: 'projekty', kind: 'project', reserved: [] },
  { section: 'realizacje', kind: 'realization', reserved: [] },
];

const RECORD_ID = /^[A-Za-z0-9_-]{1,64}$/;

/** Ekran (pierwszy człon adresu) i ewentualnie rekord, który jest na nim otwarty. */
export function activityTarget(pathname: string): {
  section: string;
  target: ActivityTarget | null;
} {
  const [first = '', second] = pathname.split('/').filter(Boolean);
  const section =
    first
      .toLowerCase()
      .replace(/[^a-z0-9-]/g, '')
      .slice(0, 40) || 'start';
  const route = DETAIL_ROUTES.find((r) => r.section === section);
  if (!route || !second || route.reserved.includes(second) || !RECORD_ID.test(second)) {
    return { section, target: null };
  }
  return { section, target: { kind: route.kind, id: second } };
}
